import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-founder-home',
  templateUrl: './founder-home.component.html',
  styleUrls: ['../../new-home/main-page.component.scss']
})
export class FounderHomeComponent implements OnInit {

  constructor(){}

  ngOnInit(): void {
    
  }

  gotolink(val:any) {
    window.open(val, '_blank')

  }

}
